module.exports = __webpack_public_path__ + "d1d2a14c918a666e7bd6172b0a28dd0b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/svg/report.svg
// module id = 1051
// module chunks = 0